
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "CROIBPCICOAA",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/CROIBPCICOAA.vue